import React from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import {useAreaBookingZoneQueryQuery} from "../../generated/graphql";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const AreaBookingZone = (props) => {
    const query = useAreaBookingZoneQueryQuery();
    return props.valueIsId?
        <GraphQlSelectId queryResult={query} {...props}  labelField="name" />:
        <GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}